import { useTranslations } from '@vocab/react';
/* eslint-disable no-param-reassign */
import { Box, FieldMessage } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import translations from './.vocab';

interface Props {
  id: string;
  className?: string;
  characterLimit?: number;
  currentCharacterCount?: number;
  helpText?: ReactNode;
  message?: string | null;
  valid?: boolean;
}

export const Message = ({
  id,
  className,
  helpText,
  message,
  characterLimit = 0,
  currentCharacterCount = 0,
  valid = true,
}: Props) => {
  const { t } = useTranslations(translations);

  if (
    !message &&
    characterLimit !== 0 &&
    currentCharacterCount > characterLimit
  ) {
    message = t('text-editor-message-character-limit-exceeded');
    valid = false;
  }
  return (
    <Box className={className}>
      {message && (
        <FieldMessage
          id={`${id}_validation_message`}
          data={{ testid: 'textEditorErrorMsg' }}
          message={message}
          tone={valid ? 'neutral' : 'critical'}
        />
      )}
      {helpText}
    </Box>
  );
};
